module.exports = __webpack_public_path__ + "static/media/ic_service_layout_grid.df48a747.svg";